import * as React from 'react';

import {
  Card,
  CardContent,
  createStyles,
  Grid,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

import Link from './Link';
import { IPageDataItems } from '../utils/declarations';
import { card } from '../styles/cards';

const styles = () =>
  createStyles({
    card: { ...card },
  });

interface ICategoryCardsProps extends WithStyles<typeof styles> {
  cardItems: IPageDataItems[];
}

/*
The cards present on component category pages which list the component pages
*/
const CategoryCards: React.FunctionComponent<ICategoryCardsProps> = ({ classes, cardItems }) => {
  return (
    <Grid container constrained spacing={3} margin={{ top: 4 }}>
      {cardItems.map((component) => {
        const { title, slug, intro }: IPageDataItems = component;

        return (
          <Grid key={slug} item container sm={6} md={4}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="h3" color="textPrimary" gutterBottom>
                  <Link href={slug} underline="always" color="primary">
                    {title}
                  </Link>
                </Typography>
                <Typography>{intro}</Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default withStyles(styles)(CategoryCards);
